import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';

class AdminDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="about-area pd-top-100 pd-bottom-100" style={{backgroundImage: 'url("'+publicUrl+'assets/img/bg/2.png")'}}>
			  <div className="container">
			    <div className="about-area-inner">
			      <div className="row">
			        <div className="col-lg-4 order-lg-12 align-self-center">
						<ScrollAnimation animateIn="fadeInRight">
			          		<img src={publicUrl+"assets/img/website/chairman.jpg"} alt="img" style={{borderRadius:'50%'}} />
						</ScrollAnimation>	
			        </div>
			        <div className="col-lg-8 order-lg-1 align-self-center mt-4 mt-lg-0">
			          <div className="about-inner-wrap">  
			            <div className="section-title mb-0">
							<ScrollAnimation animateIn="fadeInLeft">
								<h5 className='courHeading' style={{textAlign:'left'}}><Link to="/">Chairman's Message</Link></h5>
							</ScrollAnimation>
							<ScrollAnimation animateIn="fadeInLeft">
								<h2 className="title">Dr. T M GUNARAJA</h2>
								<p>F.I.E.,F.I.Mech.E.,Ph.D,</p>
							</ScrollAnimation>
							<ScrollAnimation animateIn="fadeInLeft">
								<p className="content">I have a great pleasure in welcoming you to our institute Madras Institute of Engineering Technology (MIET) established in the year 1989, is run by the “Vinayaka Trust”. TMG Industrial Training Centre (MIET- ITC) and Industrial School are the ventures of MIET group of institutions.</p>
                                <p>I’m honored to say that our institute has accomplished more than three decades of service in this education field. Our institute is situated in the heart of City, near Kodambakkam Railway Station and Bus Stand. The institute is reputed for expert faculty, well-equipped workshops, and labs, latest audio-visual aids, facility to undergo practical training, post institutional apprenticeship and placement services.</p>
                                <p>We provide education where there is a clear identified need of high quality learning opportunity in flexible, open formats, helping to meet education and training needs ranging from basic skills to excellence.</p>
                                <p>We work with the axiom “Knowledge is Power” which has a lot of truth in it. Knowledge plays an important role in all spheres of human life and activity. It is a powerful factor which helps man to attain success, power and position in life. There is no doubt that physical strength and money are instruments of power. But the power of knowledge is still greater. Knowledge helps one to overcome his weakness and faults and face dangers and difficulties with courage and confidence. It gives him mental, moral and spiritual advancement.</p>
                                <p>We trust that mighty minds with power of knowledge can rule the minds of millions.</p>
                                <p>We do offer Engineering Degree, Diploma level courses, Hotel Management and Catering courses. TMG College of Arts & Science in Manimangalam, another unit of our group offers undergraduate and postgraduate courses.</p>
                                <p>Our best wishes for each of you to succeed and achieve goal of excellence.</p>
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeInLeft">
                                <h4 className="title">Dr. T M GUNARAJA</h4>
								<p> F.I.E.,F.I.Mech.E.,Ph.D,</p>
                                <img src={publicUrl+"assets/img/website/TMG_Sign.png"} alt="img" />
                                
								<p>CHAIRMAN</p>
                               
                            </ScrollAnimation>
			            </div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default AdminDetails